<template>
  <div class="h-full w-full py-10px">
    <div
      class="border-l-[3px] border-solid border-[var(--buttonPrimaryBg)] pl-10px mb-10px flex justify-between items-center"
    >
      <span>{{ mode === 'view' ? '计划信息' : mode === 'edit' ? '编辑计划' : '新增计划' }}</span>
    </div>
    <div>
      <el-form :model="formData" ref="planFormRef" label-width="160px">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              label="项目计划名称"
              prop="name"
              :rules="[{ required: true, message: '项目计划名称必填' }]"
            >
              <el-input
                v-model.trim="formData.name"
                :maxlength="50"
                @change="changeTable"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item
              label="项目计划编码"
              prop="code"
              :rules="[{ required: true, message: '项目计划编码必填' }]"
            >
              <el-input v-model.trim="formData.code" @change="changeTable"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="所属项目"
              prop="projectId"
              :rules="[{ required: true, message: '所属项目必填' }]"
            >
              <el-select v-model="formData.projectId">
                <el-option
                  v-for="item in projectOptions"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              label="计划日期"
              prop="code"
              :rules="[{ required: true, message: '计划日期必填' }]"
            >
              <el-date-picker v-model="formData.startTime" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="计划工期"
              prop="period"
              :rules="[{ required: true, message: '计划工期必填' }]"
            >
              <el-input-number :min="1" :precision="0" v-model="formData.period"></el-input-number>
              <span class="text-[var(--contentTextColor)]"> 天</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计划描述" prop="description">
              <el-input
                type="textarea"
                v-model="formData.description"
                :maxlength="5000"
                :autosize="{ minRows: 3, maxRows: 3 }"
                resize="none"
                size="small"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="border-l-[3px] border-solid border-[var(--buttonPrimaryBg)] pl-10px mb-10px flex justify-between items-center"
    >
      <span>计划进度分解</span>
    </div>
    <div class="text-right mb-10px">
      <el-button size="mini">计划导入</el-button>
    </div>
    <div class="h-[calc(100%-280px)] mb-10px">
      <el-table height="100%" :data="tableData">
        <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :fixed="item.fixed || false"
          show-overflow-tooltip
        >
          <template slot-scope="{ column, row, $index }">
            <div v-if="column.property === 'level'">
              <el-select v-model="row[column.property]">
                <el-option
                  v-for="item in levelList"
                  :key="item.id"
                  :value="item.code"
                  :label="item.displayName"
                ></el-option>
              </el-select>
            </div>
            <div v-else-if="column.property === 'personIds'">
              <el-select v-model="row[column.property]">
                <el-option
                  v-for="item in personList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </div>
            <div v-else>
              <el-input
                v-if="$index !== 0 && column.property !== 'seqNo'"
                v-model="row[column.property]"
              ></el-input>
              <span v-else>{{ row[column.property] }}</span>
            </div>
          </template>
          <template #header="{ column }">
            <div v-if="['level', 'code', 'name'].includes(column.property)">
              <span class="text-[#F56C6C]">*</span> {{ column.label }}
            </div>
            <span v-else>
              {{ column.label }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="200px" fixed="right">
          <template slot-scope="{ row, $index }">
            <div>
              <el-button
                v-if="row.seqNo.split('.').length !== 3"
                class="mr-10px"
                size="mini"
                @click="addItem(row, $index)"
                >添加</el-button
              >
              <el-button
                v-if="$index !== 0"
                class="mr-10px"
                size="mini"
                @click="deleteItem(row, $index)"
                >删除</el-button
              >
            </div>
          </template></el-table-column
        >
      </el-table>
    </div>

    <div class="text-center">
      <el-button class="mr-0px" type="primary" @click="submit">保存</el-button>
      <el-button>取消</el-button>
    </div>
  </div>
</template>

<script>
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { DataCategoryApi } from '@wiz-api/data-category-management'

const dataCategoryApi = new DataCategoryApi()

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  data() {
    return {
      formData: {},
      projectOptions: [],
      columns: [
        { prop: 'seqNo', label: '序号', width: 60 },
        { prop: 'code', label: 'WBS编码', width: 180 },
        { prop: 'name', label: 'WBS名称' },
        { prop: 'level', label: '计划级别' },
        { prop: 'personIds', label: '相关负责人' },
      ],
      tableData: [],
      personList: [],
      levelList: [],
    }
  },
  computed: {
    mode() {
      return this.$route.query.mode
    },
  },
  methods: {
    addItem(row, index) {
      const ar = row.seqNo.split('.')
      const count = this.tableData.filter((o) => {
        return o.seqNo === row.seqNo || o.seqNo.indexOf(`${row.seqNo}.`) === 0
      })
      const lastIndex = _.findLastIndex(this.tableData, (i) => {
        return i.seqNo === count[count.length - 1]?.seqNo
      })
      const ii = lastIndex >= 0 ? lastIndex + 1 : index + 1
      const cr = count[count.length - 1]?.seqNo.split('.')
      this.tableData.splice(ii, 0, {
        seqNo:
          cr && cr.length >= ar.length + 1
            ? `${row.seqNo}.${Number(cr[ar.length]) + 1}`
            : `${row.seqNo}.${count.length}`,
        name: '',
        code: '',
        level: `${ar.length}`,
      })
    },
    deleteItem(row, index) {
      console.log(this.tableData)
      const ar = row.seqNo.split('.')
      const list = this.tableData.filter((e) => {
        return e.seqNo.indexOf(row.seqNo) !== 0
      })
      list.forEach((o) => {
        const or = o.seqNo.split('.')
        if (
          o.seqNo !== ar.slice(0, ar.length - 1).join('.') &&
          o.seqNo.indexOf(ar.slice(0, ar.length - 1).join('.')) === 0 &&
          or[or.length - 1] > ar[ar.length - 1] &&
          or.length === ar.length
        ) {
          const items = list.filter((e) => {
            return e.seqNo.indexOf(o.seqNo) === 0 && e.seqNo !== o.seqNo
          })
          o.seqNo = `${or.slice(0, or.length - 1).join('.')}.${or[or.length - 1] - 1}`
          items.forEach((q, i) => {
            const qr = q.seqNo.split('.')
            q.seqNo = `${o.seqNo}.${qr[qr.length - 1]}`
          })
        }
      })

      this.tableData = list
    },
    changeTable() {
      if (this.tableData.length === 0) {
        this.tableData.push({
          seqNo: '1',
          name: this.formData.name,
          code: this.formData.code,
          level: '0',
        })
      } else {
        this.tableData[0].name = this.formData.name
        this.tableData[0].code = this.formData.code
      }
    },
    async getPersonList() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        includeOrgChild: true, // 是否查询该部门子部门人员
        skipCount: 0,
        maxResultCount: 10000,
      })
      if (!err && res) {
        this.personList = res.items
      }
    },

    async getLevel() {
      const [err, res] = await dataCategoryApi.getByCode({
        code: 'scheduleLevel',
        includeDetails: true,
      })
      if (!err) {
        this.levelList = res.dataItems
      }
    },
    async submit() {
      await this.$refs.planFormRef.validate()
      const item = this.tableData.find((o) => {
        return !o.code.trim() || !o.name.trim() || !o.level
      })
      if (item) {
        return this.$message.error(`序号为${item.seqNo}的必填信息为空！`)
      }
    },
  },
  mounted() {
    this.getLevel()
    this.getPersonList()
  },
}
</script>
